import { useDispatch, useSelector } from 'react-redux';

import {
  resetFilters,
  setFilter,
  setNamedFilters,
  setOrderBy,
  setPagination
} from '@common/slices';
import { IFilterModel, IOrderBy, IPagination } from '@common/types';
import { RootState } from '@core/redux/store';
import { IAbstractRecord } from '@models';

export const useListFilters = (page: string) => {
  const dispatch = useDispatch();
  const filters = useSelector((state: RootState) => state.filterState[page]);

  return {
    filters,
    updateFilters: (data: IFilterModel) =>
      dispatch(setFilter({ page, filter: data })),
    setNamedFilters: (data: IAbstractRecord) =>
      dispatch(setNamedFilters({ page, namedFilters: data })),
    setPagination: (pageData: IPagination) =>
      dispatch(setPagination({ page, pagination: pageData })),
    setOrderBy: (orderData: IOrderBy) =>
      dispatch(setOrderBy({ page, ...orderData })),
    reset: () => dispatch(resetFilters({ page }))
  };
};
